import type { Distance, RGBColor } from "@pdfking/math"
import { ZERO_MARGINS, ZERO_POINT } from "@pdfking/math/constants"
import type { PageNumber } from "@pdfking/renderer-api"
import { ContentRenderer } from "@pdfking/templates"

import type { Animation } from "#public"
import type { Book } from "#public"

const default_book: Book = {
  blocks: [
    {
      paper_color: { alpha: 1, blue: 1, green: 1, red: 1 } as RGBColor,
      paper_roughness: 0.9,
      print_front: true,
      print_rear: true,
      sheets: 20 as PageNumber,
      copies: 1,
      pieces: [],
      folds: [],
      outline: [],
      holes: [],
      renderer: ContentRenderer.BOOK,
      is_cover: false,
      security: ZERO_MARGINS,
      size: {
        depth: 0.06 as Distance,
        height: 1.71 as Distance,
        width: 1.28 as Distance,
      },
    },
  ],
  blocks_offset: ZERO_POINT,
  opening_axis: "x",
}

export const defaults = {
  ambient_only: false,
  animation: "normal" as Animation,

  book: default_book,
  camera_auto_return: true,
  camera_debug_arrow: false,
  camera_flip: false,
  camera_return_delay: 500,
  camera_return_speed: 0.1,
  camera_zoom: 1.4,
  easing_factor: 0.5,
  // How far a fold stands off flat, open or closed, 0 to 1 of the most it
  // may (MAX_AJAR), scaling each fold's own `ajar`
  ajar: 1,

  frame_selected: 0,
  loading_color: { alpha: 1, blue: 0, green: 0.65, red: 1 } as RGBColor,

  opening_segments: 4,
  page_elevation: 0,
  page_segments: 30,
  pile_distance: 1.5,
  // How much of its slot a sheet fills, the cover's too: the rest is air
  // between sheets, the book as thick whatever it is
  sheet_fill: 0.8,
}

export type SettingsValues = typeof defaults

export type SettingsKey = keyof typeof defaults
